export const MODE_VERIFY_EMAIL = "verifyEmail";
export const MODE_RESET_PASSWORD = "resetPassword";
